import React, {
  useEffect,
  useState,
  useContext
} from 'react';
import {
  Box,
  Container,
  Button,
  makeStyles
} from '@material-ui/core';
import { NavLink as RouterLink, Navigate } from 'react-router-dom';
import Page from 'src/components/Page';
import Tabelas from '../../../shared/component/UIElements/Tabelas';
import { useHttpClient } from '../../../hooks/http-hook';
import { AuthContext } from '../../../shared/context/auth-context';
import ErrorMessage from '../../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../../shared/component/UIElements/LoadingSpinner';
import Modal from '../../../shared/component/Modal';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  button: {
    color: 'white',
    paddingRight: '40px',
    paddingLeft: '40px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px'
  }
}));

const CustomerListView = () => {
  const auth = useContext(AuthContext);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const classes = useStyles();
  const [usuarios, setUsuarios] = useState([]);
  const [query, setQuery] = useState(null);
  const [navegar, setNavegar] = useState(false);
  const [remover, setRemover] = useState(false);
  const handleEdit = (qual) => {
    setNavegar(`usuarios/${qual}`);
  };
  const handleDelete = async () => {
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/usuarios/${remover}`,
        'DELETE',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(responseData);
      if (responseData.sucesso) {
        setUsuarios((prevState) => {
          const data = [...prevState.filter((item) => item.id !== remover)];
          setRemover(false);
          return data;
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const abrirDeletar = (qual) => {
    setRemover(qual);
  };

  const fecharDeletar = () => {
    setRemover(false);
  };
  const handleBusca = (event) => {
    const searchLower = String(event.target.value).toLowerCase();
    if (String(searchLower).trim().length > 0) {
      const filtradas = usuarios.filter((usuario) => String(usuario.nome.conteudo).toLowerCase().includes(searchLower)
        || String(usuario.email.conteudo).toLowerCase().includes(searchLower));
      console.log(filtradas);
      setQuery(filtradas);
    } else {
      setQuery(null);
    }
  };
  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/usuarios/`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        setUsuarios(() => {
          const data = [...responseData.data.map((usuario) => ({
            id: usuario._id,
            nome: {
              conteudo: usuario.nome,
              avatar: usuario.avatar !== undefined ? `${process.env.REACT_APP_BACKEND_IMG}${usuario.avatar.caminho}` : '',
              tipo: 'avatar'
            },
            criacao: {
              conteudo: new Date(usuario.createdDate).toLocaleString(),
              tipo: 'data'
            },
            email: {
              conteudo: usuario.email,
              tipo: 'texto'
            },
            permissao: {
              conteudo: usuario.permissao.nome,
              tipo: 'texto'
            },
            edit: responseData.editar,
            delete: responseData.deletar
          }))];
          return data;
        });
      } catch (err) {
        console.log(err);
      }
    };
    fetchUsuarios();
  }, [sendRequest, auth]);
  const LinkBehavior = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/app/usuarios/novo" exact {...props} />
  ));
  if (navegar) {
    return <Navigate to={`/app/${navegar}`} />;
  }
  return (
    <Page
      className={classes.root}
      title="Usuários"
    >
      <Container maxWidth={false}>
        <Box mt={3}>
          <Box
            display="flex"
            justifyContent="flex-start"
            pb={4}
          >
            {(auth.userPermission.permissoes.includes('all_admin') || auth.userPermission.nome === 'Gestor do Sistema') && (
              <Button
                color="secondary"
                variant="contained"
                className={classes.button}
                component={LinkBehavior}
              >
                Adicionar Usuário
              </Button>
            )}
          </Box>
          {isLoading && <LoadingSpinner asOverlay />}
          <Tabelas
            data={query !== null ? query : usuarios}
            placeholder="Pesquisar Usuário"
            estrutura={[
              { id: 'nome', tipo: 'avatar', nome: 'Nome' },
              { id: 'criacao', tipo: 'data', nome: 'Data de Criação' },
              { id: 'email', tipo: 'texto', nome: 'E-mail' },
              { id: 'permissao', tipo: 'texto', nome: 'Nível de Acesso' },
              { id: 'acoes', tipo: 'acoes', nome: 'Ações' },
            ]}
            edit={handleEdit}
            remove={abrirDeletar}
            busca={handleBusca}
          />
          <ErrorMessage error={error} onClear={clearError} />
        </Box>
        <Modal
          open={remover}
          close={fecharDeletar}
          title="Deseja realmente remover este usuario?"
        >
          <Button
            color="primary"
            variant="contained"
            style={{ marginRight: '15px' }}
            onClick={handleDelete}
          >
            Remover Usuário
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={fecharDeletar}
          >
            Cancelar
          </Button>
        </Modal>
      </Container>
    </Page>
  );
};

export default CustomerListView;
